module.exports = __webpack_public_path__ + "files/coffee.809877f02fd9f83b97015b79d6127939.gif";